/**
 * Aturan pengelolaan akun pengguna yang dipakai bersama API dan web.
 *
 * Backend tetap penegak utama (lihat `apps/api/src/auth/scope.ts`); web hanya
 * memakai berkas ini untuk menyusun pilihan pada formulir sehingga daftar peran
 * yang tampil tidak pernah berbeda dari yang diizinkan server.
 */
/** Peran yang boleh membuka menu Kelola Pengguna dan membuat akun baru. */
export const USER_MANAGE_ROLES = [
    "PRODI_ADMIN",
    "FAKULTAS_ADMIN",
    "INSTITUT_ADMIN",
];
/**
 * Peran yang boleh dibuat oleh masing-masing peran pembuat.
 * Admin yang lebih tinggi boleh membuat akun setingkat (agar tidak ada
 * administrator tunggal), tetapi tidak boleh melampaui lingkupnya sendiri.
 */
export const CREATABLE_ROLES = {
    INSTITUT_ADMIN: [
        "MAHASISWA",
        "DOSEN",
        "PRODI_ADMIN",
        "FAKULTAS_ADMIN",
        "UNIT_OPERATOR",
        "INSTITUT_ADMIN",
    ],
    FAKULTAS_ADMIN: ["MAHASISWA", "DOSEN", "PRODI_ADMIN", "UNIT_OPERATOR"],
    PRODI_ADMIN: ["MAHASISWA", "DOSEN", "UNIT_OPERATOR"],
    DOSEN: [],
    MAHASISWA: [],
    UNIT_OPERATOR: [],
};
/** Peran yang wajib terikat satu program studi (fakultas mengikuti program studi). */
export const STUDY_PROGRAM_BOUND_ROLES = [
    "MAHASISWA",
    "DOSEN",
    "PRODI_ADMIN",
    "UNIT_OPERATOR",
];
/** Peran yang terikat fakultas tanpa program studi. */
export const FACULTY_BOUND_ROLES = ["FAKULTAS_ADMIN"];
/** Peran yang wajib terikat satu unit di dalam program studinya. */
export const UNIT_BOUND_ROLES = ["UNIT_OPERATOR"];
/**
 * Peran yang boleh didaftarkan sendiri lewat halaman pendaftaran publik.
 * Peran admin SENGAJA tidak dapat didaftarkan sendiri — akun admin hanya
 * dibuat oleh administrator lain melalui menu Kelola Pengguna.
 */
export const SELF_REGISTER_ROLES = ["MAHASISWA", "DOSEN", "UNIT_OPERATOR"];
/**
 * Peran yang boleh menyetujui atau menolak pendaftaran akun, dibatasi pada
 * lingkupnya sendiri (lihat `apps/api/src/auth/scope.ts`).
 */
export const USER_APPROVE_ROLES = [
    "PRODI_ADMIN",
    "FAKULTAS_ADMIN",
    "INSTITUT_ADMIN",
];
export function canManageUsers(role) {
    return role ? USER_MANAGE_ROLES.includes(role) : false;
}
export function canApproveUsers(role) {
    return role ? USER_APPROVE_ROLES.includes(role) : false;
}
export function canSelfRegister(role) {
    return role ? SELF_REGISTER_ROLES.includes(role) : false;
}
export function creatableRolesFor(role) {
    return role ? CREATABLE_ROLES[role] : [];
}
export function canCreateRole(actorRole, targetRole) {
    return creatableRolesFor(actorRole).includes(targetRole);
}
export function roleNeedsStudyProgram(role) {
    return STUDY_PROGRAM_BOUND_ROLES.includes(role);
}
export function roleNeedsFaculty(role) {
    return FACULTY_BOUND_ROLES.includes(role);
}
export function roleNeedsUnit(role) {
    return UNIT_BOUND_ROLES.includes(role);
}
//# sourceMappingURL=users.js.map